import classes from './Pagination.module.css'
import clsx from 'clsx'

export function Pagination() {
  return null
  return (
    <ul className={classes.pagination}>
      <li className={classes.paginationItem}>
        <a href='#'>{'<'}</a>
      </li>
      <li className={classes.paginationItem}>
        <a href='#'>...</a>
      </li>
      <li className={classes.paginationItem}>
        <a href='#'>9</a>
      </li>
      <li
        className={clsx(classes.paginationItem, classes.paginationItem__active)}
      >
        <a href='#'>10</a>
      </li>
      <li className={classes.paginationItem}>
        <a href='#'>{'>'}</a>
      </li>
    </ul>
  )
}
